import { createApp } from 'vue'
import { Dialog, Notify, Quasar } from 'quasar'
import { i18n } from 'js/vue/i18n'
import { lang } from 'store/lang.store'
import { NotifyInit } from './boot/Notify'
import LayoutBase from 'layouts/LayoutBase.vue'
import moneyFormat from './directives/moneyFormat'
import quasarEN from 'quasar/lang/en-US'
import quasarES from 'quasar/lang/es'
import quasarPT from 'quasar/lang/pt-BR'
import router from './router/router'
import VueKeyboardTrapDirectivePlugin from '@pdanpdan/vue-keyboard-trap'

NotifyInit()

const context = {
  ...window.context,
}
const app = createApp(LayoutBase)

app.provide('context', context)
app.config.globalProperties.$console = console.log

const language = {
  'pt-BR': quasarPT,
  'en-US': quasarEN,
  es: quasarES,
}

app.use(i18n)
app.use(router)
app.use(Quasar, {
  plugins: {
    Notify,
    Dialog,
  },
  lang: language[lang.value],
  config: {
    notify: {},
    screen: {
      bodyClasses: true,
    },
    ripple: {
      early: true,
    },
  },
})
app.use(VueKeyboardTrapDirectivePlugin, {})

app.directive('money-format', moneyFormat)

console.log(
  '----------------------------------------- NOVADATA 24-10-2025 ---------------------------------'
)
app.mount('#app')
